module.exports = __webpack_public_path__ + "static/media/person2.64621296.png";